function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 100 100"
}, props), /*#__PURE__*/React.createElement("path", {
  style: {
    textIndent: "0",
    textAlign: "start",
    lineHeight: "normal",
    textTransform: "none",
    blockProgression: "tb",
    marker: "none",
    InkscapeFontSpecification: "Sans"
  },
  d: "M50 6C25.723 6 6 25.723 6 50s19.723 44 44 44 44-19.723 44-44S74.277 6 50 6zm0 4c22.115 0 40 17.885 40 40S72.115 90 50 90 10 72.115 10 50s17.885-40 40-40zM32.781 30.969a2 2 0 00-1.187 3.437L47.187 50 31.595 65.563a2 2 0 102.812 2.843L50 52.812l15.594 15.594a2 2 0 102.812-2.844L52.812 50l15.594-15.594a2 2 0 00-1.656-3.437 2 2 0 00-1.156.593L50 47.157 34.406 31.563a2 2 0 00-1.625-.594z",
  fontWeight: "400",
  color: "#000",
  overflow: "visible",
  fontFamily: "Sans"
}));